import { Component, forwardRef, input, output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { FormBaseControlComponent } from '../base';
import { ButtonComponent } from '../../../ava-button/ava-button.component';
import { FormErrorComponent } from '../../errors';
import { promoCode } from '../../../../../store/form-messages';
import { AlertComponent } from '../../../alert';

@Component({
  selector: 'ava-form-promocode',
  template: `
    <div class="promocode__formcontrol">
      <nz-form-item class="tw-mb-0">
        <nz-form-control [nzValidateStatus]="formControlStatus" [nzErrorTip]="errors" nzHasFeedback>
          <nz-input-group [nzSuffix]="inputClearTpl">
            <input
              [formControl]="formControl()"
              [id]="controlId() || formControlName()"
              placeholder="Promo Code"
              nz-input
              class="ava-form-control"
            />
          </nz-input-group>

          @if (warningMessage() && isLoading() === false) {
            <div class="ava-form-error">{{ warningMessage() }}</div>
          }
          <ng-template #errors let-control>
            <ava-form-errors [control]="formControl()" [messages]="errorMessages()" />
          </ng-template>
          <ng-template #inputClearTpl>
            @if (formControl()?.value) {
              <span
                nz-icon
                class="ant-input-clear-icon"
                nzTheme="fill"
                nzType="close-circle"
                (click)="handleClearPromo()"
              ></span>
            }
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <ava-button
        [disabled]="formControl().disabled"
        label="Apply"
        (clicked)="applyPromoCode.emit()"
        [isLoading]="isLoading()"
        class="tw-text-base"
      />
    </div>

    <ava-alert [timeout]="100000000" type="info" [closeable]="false" [description]="promoDescription()" />
  `,
  styles: [
    `
      :host {
        .promocode__formcontrol {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: flex-start;
          gap: 1rem;
        }

        input::placeholder {
          font-weight: 200;
          font-size: 16px;
          color: var(--ava-form-control-placeholder-colour);
        }

        .ava-form-control {
          font-weight: 400;
        }
      }
    `,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormInputPromoCodeComponent),
      multi: true,
    },
  ],
  imports: [
    ButtonComponent,
    FormErrorComponent,
    NzFormModule,
    NzGridModule,
    NzIconModule,
    NzInputModule,
    ReactiveFormsModule,
    AlertComponent,
  ],
  standalone: true,
})
export class FormInputPromoCodeComponent extends FormBaseControlComponent {
  override errorMessages = input<{ [key: string]: string }>(promoCode);
  promoDescription = input('');
  isLoading = input<boolean | null>(false);
  warningMessage = input('');

  applyPromoCode = output();

  handleClearPromo() {
    this.formControl().setValue('');
    this.applyPromoCode.emit();
  }
}
